"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M16.673 8.226C15.83 7.17 14.507 6.32 13.2 6v1.609a4.642 4.642 0 012.297 1.552c.654.822 1 1.813 1 2.865a4.555 4.555 0 01-1 2.866 4.642 4.642 0 01-2.297 1.552V18c1.307-.32 2.631-1.117 3.473-2.174a6.123 6.123 0 001.327-3.8 6.124 6.124 0 00-1.327-3.8zM11.816 6.6l-3.31 3.328h-1.43A1.08 1.08 0 006 11.015v1.97c0 .6.481 1.087 1.076 1.087h1.43l3.31 3.328V6.6z" }),
    React.createElement("path", { d: "M13.2 9v6c1.246-.555 2.1-1.69 2.1-3s-.855-2.445-2.1-3z" })), "Loud");
//# sourceMappingURL=VolumeLoud.js.map